
import { Question, QuestionI } from '@/components/Public/Question/lib/interface';
import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Button } from 'ant-design-vue';

export default defineComponent({
  components: {
    breadcrumb: defineAsyncComponent(() => import('@/components/Breadcrumbs.vue')),
    question: defineAsyncComponent(() => import('@/components/Public/Question/Index.vue')),
    aButton: Button,
  },
  props: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const goInfo = () => {
      router.push('/Teacher/experimentinfo');
    };

    const showQuestion = ref(false);

    const questionData = new Question();

    const handleQuestionOk = (data: QuestionI) => {
      Object.assign(questionData, data);
      showQuestion.value = false;
    };

    return {
      breadcrumb: { breadcrumbName: '一级页面', path: route.path },
      showQuestion,
      questionData,
      handleQuestionOk,
      goInfo,
    };
  },
});
